// extracted by mini-css-extract-plugin
export var speakers = "speakerlist-module--speakers--3EdGd";
export var inner = "speakerlist-module--inner--271oq";
export var list = "speakerlist-module--list--bDAM5";
export var center = "speakerlist-module--center--2oDfe";
export var mc = "speakerlist-module--mc--17J5c";
export var deco_1 = "speakerlist-module--deco_1--18aMU";
export var deco_2 = "speakerlist-module--deco_2--Z_-Q-";